import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";

const ClearSelectsModal = ({ isOpen, toggle, handleConfirm, value }) => {
    return (
        <>
        <Modal
          centered
          isOpen={isOpen}
          toggle={(e) => toggle(e)}
          backdrop
        >
          <ModalHeader toggle={toggle}>
            Clear All Match Selections?
          </ModalHeader>
          <ModalBody>
            <Alert color="warning" className="d-flex">
              <i className="bi bi-exclamation-triangle-fill"></i>
              <div>
                Warning: This change will apply to all files selected and override any previous match level selections.
              </div>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button className="promote" onClick={toggle}>
              Cancel
            </Button>
            <Button onClick={()=> handleConfirm(value, true)}>Clear Match Selections</Button>
          </ModalFooter>
        </Modal>
      </>
    );
}

export default ClearSelectsModal;